module.exports = __webpack_public_path__ + "media/playing_full_house_1.202d4364.mp3";